import React from "react";

/* eslint-disable */
import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

const icon = require("../../../assets/Detasad Cloud/main_icon_highperformance.svg");

const CloudEmailSecurity = () => {
    const heading = `CLOUD EMAIL SECURITY `;
    const details = `Protect your on-premises or cloud-based email service by our advance email security protection service. `;

    const overview = [
        `DETASAD provides a cloud email security solution which can easily integrate with your existing email infrastructure whether on-premises or in any public-cloud. DETASAD email security service filters your emails and make them safe for your team with its enterprise-grade email security layers as well as an add-on advanced threat protection layer. `
    ];

    const advantages = [
        [
            `Multilayer Anti-Spam Engine`,
            `DETASAD ensures the elimination of threats before they reach your corporate firewall with its built-in multi-layered, real-time anti-spam and multi-engine anti-malware protection.`,
            icon
        ],
        [
            `Rate Control`,
            `It protects your company's resources and IP reputation by using outbound rate control and spam filter solutions.`,
            icon
        ],
        [
            `Guaranteed SLA`,
            `Our service is backed by SLAs which attest to a high quality of service, including protection from 99.99% of known viruses and 99% of spam.`,
            icon
        ],
        [
            `Maximum Uptime`,
            `Geographical load-balanced network of datacenters helps to ensure a maximum network uptime.`,
            icon
        ]
    ];

    const functions = [
        [
            `Advanced Protection`,
            [
                `DETASAD’s Cloud Email Security offers a comprehensive email security against spear phishing and other advanced, multi-stage and zero-day attacks. `
            ]
        ],
        [
            `In-Depth Threat Scanning`,
            [
                `It analyzes emails for threats hidden in files including password-protected or encrypted attachments and malicious URLs. `
            ]
        ],
        [
            `Automatic Detection`,
            [`DETASAD Cloud Email Security can automatically detect and block credential phishing.`]
        ]
    ];

    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-collab"/>
            <SubNav overview={overview} advantages={advantages} functions={functions} />
            <Footer />
        </div>
    );
};

export default CloudEmailSecurity;
